<template>
    <div id="app" class="uk-container">
        <fieldset class="uk-fieldset step_design">

            <header>
                <div><img src="./assets/image_logo.png"></div>
                <h1>レールカット 計算ツール</h1>
            </header>
            <!--非選択時   <div class="disabled_step"> -->
            <!--選択可能時 <div class="active_step">   -->
            <!--選択完了時 <div class="sucsess_step">  -->

            <div :class="this.step_data.step_1" id="step1">
                <div class="display_overlay"></div>
                <h2>STEP1</h2>
                <div class="step_title">キャップを含むレールの全長を入力してください</div>
                <div class="uk-margin">

                    <div uk-grid>
                        <div class="uk-width-auto@m">
                            <input class="uk-width-1-2 uk-input uk-text-right" type="text"
                                   pattern="\d*"
                                   v-on:focus="changeTypeNum1"
                                   @keydown.enter="trigger"
                                   v-on:blur="toInput_step_1" :model="form_data.step_1">&nbsp;&nbsp;&nbsp;mm
                        </div>
                        <div class="uk-width-1-2 uk-width-1-3@m">
                            <img src="./assets/image_01.png" width="400" height="400" alt="image">
                        </div>
                        <div class="uk-width-1-2 uk-width-expand@m uk-inline">
                            <p class="step-text uk-position-bottom uk-overlay-default">
                                窓枠の外⼨に対して、以下の⻑さがお勧めの⼨法です。<br/>
                                <br/>
                                【装飾レール】<br/>
                                 <span class="spaser"></span>左右それぞれ15ｃｍ程度伸ばした⻑さ<br/>
                                【機能性レール】<br/>
                                 <span class="spaser"></span>左右それぞれ10ｃｍ程度伸ばした⻑さ
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <hr>


            <div :class="this.step_data.step_2" id="step2">
                <div class="display_overlay"></div>
                <h2 class="uk-margin-large-top">STEP2</h2>
                <div class="step_title">レールのカテゴリーを選択してください</div>

                <div class="uk-margin">
                    <div class="uk-child-width-1-3 uk-child-width-1-6@m uk-text-center my-contents-area" uk-grid>

                        <div v-for="(text_data ,index) in load_excel_data.cate_data" :key="index" >
                            <input :id="'step2-'+text_data.id" class="uk-radio" type="radio" name="radio2" :value="text_data.data" v-on:change="toInput_step_2">
                            <label :for="'step2-'+text_data.id" class="original_radio" v-html="text_data.text"></label>
                        </div>
                    </div>
                </div>
            </div>

            <hr>

            <div :class="this.step_data.step_3" id="step3">
                <div class="display_overlay"></div>
                <h2 class="uk-margin-large-top">STEP3</h2>
                <div class="step_title">製品名を選択してください</div>

                <div class="uk-margin">
                    <div class="uk-child-width-1-3 uk-child-width-1-6@m uk-text-center my-contents-area" uk-grid>

                        <div
                             v-for="(text_data ,index) in load_excel_data.item_data" :key="index"
                             class="item_box"
                             :class="(form_data.step_2 !== '' && load_excel_data.select[form_data.step_2][text_data.data] !== undefined)?'':'disabled_box'"
                        >
                            <input :id="'step3-'+text_data.id" class="uk-radio" type="radio" name="radio3" :value="text_data.data" v-on:change="toInput_step_3">
                            <label :for="'step3-'+text_data.id" class="original_radio" v-html="text_data.text"></label>
                        </div>
                    </div>
                </div>
            </div>

            <hr>

            <div
                    :class="(this.step_data.step_4 === 'disabled_step' || this.form_data.step_3 !== '' && this.load_excel_data.select[this.form_data.step_2][this.form_data.step_3]['-'] !== undefined)? 'disabled_step':this.step_data.step_4"
                    id="step4"
                    >
                <div class="display_overlay"></div>
                <h2 class="uk-margin-large-top">STEP4</h2>
                <div class="step_title">キャップを選択してください</div>

                <div class="uk-margin">
                    <div class="uk-child-width-1-3 uk-child-width-1-6@m uk-text-center my-contents-area" uk-grid>
                        <template v-if="form_data.step_3 !== ''">
                            <div

                                 v-for="(text_data ,index) in load_excel_data.sort[form_data.step_2][form_data.step_3]" :key="index"
                                 class="item_box"
                                 :class="(form_data.step_3 !== '')?'':'disabled_box'"
                            >
                                <div v-for="(text_item,index2) in text_data" :key="index2" style="padding: 0">
                                    <input :id="'step4-'+index" class="uk-radio" type="radio" name="radio4" :value="load_excel_data.cap[text_item['キャップ']]['data']" v-on:change="toInput_step_4">
                                    <label :for="'step4-'+index" class="original_radio" v-html="load_excel_data.cap[text_item['キャップ']]['text']"></label>
                                </div>

                            </div>
                        </template>
                    </div>
                </div>
            </div>

            <hr>

            <div :class="this.step_data.step_5" id="step5">
                <div class="display_overlay"></div>
                <h2 class="uk-margin-large-top">STEP5</h2>
                <div class="step_title">シングル・ダブルを選択してください</div>

                <div class="uk-margin">
                    <div class="uk-child-width-1-3 uk-child-width-1-6@m uk-text-center my-contents-area" uk-grid>

                        <div v-for="(text_data ,index) in load_excel_data.cat_data" :key="index"
                             class="item_box"
                             :class="(form_data.step_4 !== '' && load_excel_data.select[form_data.step_2][form_data.step_3][form_data.step_4][text_data.data] !== '-' )?'':'disabled_box'"
                        >
                            <input :id="'step5-'+text_data.id" class="uk-radio" type="radio" name="radio5" :value="text_data.data" v-on:change="toInput_step_5">
                            <label :for="'step5-'+text_data.id" class="original_radio" v-html="text_data.text"></label>
                        </div>
<!--                        <div class="uk-width-expand uk-text-left step-text">-->
<!--                            <p class="uk-margin-remove">※フィットアーキ・ヴィンクスシェルフ・カーテンボックスは 受注⽣産品です。</p>-->
<!--                            <p class="uk-margin-remove">※電動商品・店頭商品は対応しておりません。</p>-->
<!--                            <p class="uk-margin-remove">※コルーナⅡ・リフレは対応しておりません。</p>-->
<!--                        </div>-->
                    </div>
                </div>
            </div>

            <hr>

            <div
                    :class="(this.form_data.step_3 === 'ノルディ25' && this.form_data.step_4 === 'E' && this.form_data.step_5 !== '' && this.form_data.step_5 !== 'シングル')? this.step_data.step_6:this.step_data.step_6"
                    id="step6"
            >
                <div class="display_overlay"></div>
                <h2>STEP6</h2>
                <div class="step_title">両端ブラケットネジの取付間隔を⼊⼒してください</div>
                <div class="uk-margin">

                    <div uk-grid>
                        <div class="uk-width-auto@m">
                            <input class="uk-width-1-2 uk-input uk-text-right" type="text"
                                   pattern="\d*"
                                   v-on:focus="changeTypeNum2"
                                   @keydown.enter="trigger"
                                   v-on:blur="toInput_step_6" :model="form_data.step_6">&nbsp;&nbsp;mm
                        </div>
                        <div class="uk-width-1-2 uk-width-1-3@m">
                            <img src="./assets/image_02.png" width="400" height="400" alt="image">
                        </div>
                    </div>
                </div>
            </div>

            <div class="footer">
                <div class="uk-margin uk-container">

                    <div class="uk-child-width-1-1 uk-child-width-1-2@s" uk-grid>
                        <div>
                            <h3>選択スペック</h3>
                            <div class="spec_result">
                                <div class="spec_row">
                                    <div class="spec_title">製品仕上がりサイズ</div><div class="spec_data">{{this.form_data.step_1}}mm</div>
                                </div>

                                <div class="spec_row">
                                    <div class="spec_title">カテゴリー</div><div class="spec_data">{{this.form_data.step_2}}</div>
                                </div>

                                <div class="spec_row">
                                    <div class="spec_title">品名</div><div class="spec_data">{{this.form_data.step_3}}</div>
                                </div>

                                <div class="spec_row">
                                    <div class="spec_title">キャップ</div><div class="spec_data">{{this.form_data.step_4}}</div>
                                </div>

                                <div class="spec_row">
                                    <div class="spec_title">レール種類</div><div class="spec_data">{{this.form_data.step_5}}</div>
                                </div>

                                <div class="spec_row" v-if="this.form_data.step_6 !== ''">
                                    <div class="spec_title">両端ブラケット間隔</div><div class="spec_data">{{this.form_data.step_6}}mm</div>
                                </div>
                            </div>
                        </div>

                        <div class="length_result_1">
                            <h3>発注レール長さ</h3>
                            <div class="spec_result">
                                <div class="spec_row">
                                    <div class="spec_title">ドレープ側レール</div>
                                    <div class="spec_data length_data" :class="(total_data.total_rail === '')?'disabled_data':''">
                                        {{total_data.total_rail}}<span>mm</span>
                                    </div>
                                </div>

                                <div class="spec_row">
                                    <div class="spec_title">レース側レール <br/>（標準⻑さ）</div>
                                    <div class="spec_data length_data uk-text-right" :class="(total_data.default_rail === '')?'disabled_data':''">
                                        {{total_data.default_rail}}<span>mm</span>
                                    </div>
                                </div>

                                <div class="spec_row">
                                    <div class="spec_title">カバートップ</div>
                                    <div class="spec_data length_data uk-text-right" :class="(total_data.cover_rail === '')?'disabled_data':''">
                                        {{total_data.cover_rail}}<span>mm</span>
                                    </div>
                                </div>

                                <p class="step-text uk-width-expand uk-text-left">※10mm単位で切り捨てしています。</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="tool_tip">
                    <button class="uk-button uk-button-default" v-on:click="clear_data">クリア</button>
<!--                    <button class="uk-button uk-button-default" v-on:click="scrollTop">↑</button>-->
                    <img class="uk-button" src="./assets/to_top.jpg" style="height:49px" alt="ページトップへ" v-on:click="scrollTop">
                </div>
                <p class="l-footer__g4Copy uk-text-center">
                    Copyright©︎2002-2020 TOSO COMPANY , LIMITED All Rights Reserved.
                </p>
            </div>

            <loadXlsx/>

        </fieldset>

        <!-- Loading -->
        <div class="is_loading" v-if="is_loading">
            <p class="loader"></p>
            <p>Loading...</p>
        </div>
        <!-- Loading -->

    </div>
</template>

<script>
    const loadXlsx = () => import('./components/loadXlsx');
    // import XLSX from 'xlsx'
    export default {
        name: 'App',
        components: {
            loadXlsx
        },
        computed: {
            step_data: {
                get: function () {
                    return this.$store.state.stepData
                },
                set:function (value) {
                    this.$store.commit('input_step_data', value)
                }
            },

            form_data : {
                get: function () {
                    return this.$store.state.formData
                },
                set:function (value) {
                    this.$store.commit('input_form_data', value)
                }
            },

            load_excel_data : {
                get: function () {
                    return this.$store.state.XlsxData
                }
            },

            total_data : {
                get: function () {
                    return this.$store.state.totalData
                },
                set:function (value) {
                    this.$store.commit('update_total_data', value)
                }
            },

            is_loading:{
                get: function () {
                    return this.$store.state.is_loading
                }
            }

        },
        data() {
            return {
            }
        },
        methods: {
            /**
             * data入力時次のSTEPの状態を変更する
             */
            //step1
            toInput_step_1 : function (e){
                const scope = this
                //changeInputType
                e.target.type = 'text'
                //focus out
                document.activeElement.blur()

                //stepdata update
                if(e.target.value == ''){
                    scope.step_data.step_1 = 'active_step'
                    scope.step_data.step_2 = 'disabled_step'
                    scope.step_data.step_3 = 'disabled_step'
                    scope.step_data.step_4 = 'disabled_step'
                    scope.step_data.step_5 = 'disabled_step'
                    scope.step_data.step_6 = 'hidden_step'
                    //reset function
                    scope.reset_form_data()
                    scope.resetCalculation()
                }else{
                    scope.step_data.step_1 = 'sucsess_step'


                    if(scope.step_data.step_2 === 'sucsess_step'){
                        scope.step_data.step_2 = 'sucsess_step'
                    }else{
                        scope.step_data.step_2 = 'active_step'
                    }

                    //formdata update
                    scope.form_data.step_1 = scope.comma(Number(e.target.value))
                    e.target.value = scope.comma(Number(e.target.value))
                    this.form_data= scope.form_data

                    //計算処理起動
                    scope.Calculation()
                }
                //stepdata update
                this.step_data= scope.step_data
            },
            //step2
            toInput_step_2 : function (e){
                const scope = this
                //stepdata update
                scope.step_data.step_1 = 'sucsess_step'
                scope.step_data.step_2 = 'sucsess_step'
                scope.step_data.step_6 = 'hidden_step'

                if(scope.step_data.step_3 === 'sucsess_step'){
                    scope.step_data.step_3 = 'active_step'
                    scope.step_data.step_4 = 'disabled_step'
                    scope.step_data.step_5 = 'disabled_step'
                    scope.form_data.step_3 = ''
                    scope.form_data.step_4 = ''
                    scope.form_data.step_5 = ''
                    scope.form_data.step_6 = ''
                    scope.resetCalculation()
                    //radio all disabled
                    for (const element of document.getElementById('step3').getElementsByClassName('uk-radio')) {
                        element.checked = false;
                    }
                    for (const element of document.getElementById('step4').getElementsByClassName('uk-radio')) {
                        element.checked = false;
                    }
                    for (const element of document.getElementById('step5').getElementsByClassName('uk-radio')) {
                        element.checked = false;
                    }
                }else{
                    scope.step_data.step_3 = 'active_step'
                }

                //formdata update
                scope.form_data.step_2 = e.target.value
                this.form_data= scope.form_data

                //stepdata update
                this.step_data= scope.step_data
            },
            //step3
            toInput_step_3 : function (e){
                const scope = this
                //stepdata update
                scope.step_data.step_1 = 'sucsess_step'
                scope.step_data.step_2 = 'sucsess_step'
                scope.step_data.step_3 = 'sucsess_step'
                scope.step_data.step_6 = 'hidden_step'

                if(scope.step_data.step_4 === 'sucsess_step'){
                    scope.step_data.step_4 = 'active_step'
                    scope.step_data.step_5 = 'disabled_step'

                    scope.form_data.step_4 = ''
                    scope.form_data.step_5 = ''
                    scope.form_data.step_6 = ''
                    scope.resetCalculation()
                    //radio all disabled
                    for (const element of document.getElementById('step4').getElementsByClassName('uk-radio')) {
                        element.checked = false;
                    }
                    for (const element of document.getElementById('step5').getElementsByClassName('uk-radio')) {
                        element.checked = false;
                    }
                }else{
                    scope.step_data.step_4 = 'active_step'
                }

                //formdata update
                scope.form_data.step_3 = e.target.value
                this.form_data= scope.form_data

                //stepdata update
                this.step_data= scope.step_data
            },
            //step4
            toInput_step_4 : function (e){
                const scope = this
                //stepdata update
                scope.step_data.step_1 = 'sucsess_step'
                scope.step_data.step_2 = 'sucsess_step'
                scope.step_data.step_3 = 'sucsess_step'
                scope.step_data.step_4 = 'sucsess_step'
                scope.step_data.step_6 = 'hidden_step'
                scope.form_data.step_6 = ''
                scope.resetCalculation()
                if(scope.step_data.step_5 === 'sucsess_step'){
                    scope.step_data.step_5 = 'sucsess_step'
                    scope.form_data.step_5 = ''
                    //radio all disabled
                    for (const element of document.getElementById('step5').getElementsByClassName('uk-radio')) {
                        element.checked = false;
                    }
                }else{
                    scope.step_data.step_5 = 'active_step'
                }

                //formdata update
                scope.form_data.step_4 = e.target.value
                this.form_data= scope.form_data

                //stepdata update
                this.step_data= scope.step_data
            },
            //step5
            toInput_step_5 : function (e){
                const scope = this
                //stepdata update
                scope.step_data.step_1 = 'sucsess_step'
                scope.step_data.step_2 = 'sucsess_step'
                scope.step_data.step_3 = 'sucsess_step'
                scope.step_data.step_4 = 'sucsess_step'
                scope.step_data.step_5 = 'sucsess_step'
                scope.step_data.step_6 = 'hidden_step'
                scope.form_data.step_6 = ''
                scope.resetCalculation()
                //formdata update
                scope.form_data.step_5 = e.target.value
                this.form_data= scope.form_data

                scope.step_data.step_6 = (scope.form_data.step_3 === 'ノルディ25' && (scope.form_data.step_4 === 'E' || scope.form_data.step_4 === 'Ｅ') && scope.form_data.step_5 !== '' && scope.form_data.step_5 !== 'シングル')? 'active_step':'hidden_step'
                //stepdata update
                this.step_data= scope.step_data

                //計算処理起動
                scope.Calculation()
            },
            //step6
            toInput_step_6 : function (e){
                const scope = this

                //changeInputType
                e.target.type = 'text'
                //focus out
                document.activeElement.blur()

                //stepdata update
                scope.step_data.step_1 = 'sucsess_step'
                scope.step_data.step_2 = 'sucsess_step'
                scope.step_data.step_3 = 'sucsess_step'
                scope.step_data.step_4 = 'sucsess_step'
                scope.step_data.step_5 = 'sucsess_step'
                scope.step_data.step_6 = 'sucsess_step'

                let sprit_data = scope.load_excel_data.double[scope.form_data.step_3]['ドレープ側'][scope.form_data.step_5]
                if(isNaN(sprit_data)){
                    sprit_data = sprit_data.replace(')','').split('(Rセットの場合は')
                }

                let sprit_index = 0
                if(scope.form_data.step_4 === 'R' || scope.form_data.step_4 === 'Ｒ' ){
                    sprit_index = 1
                }

                //console.log(scope.load_excel_data.double[scope.form_data.step_3]['ドレープ側'])
                let sprit_num = ''
                if(Array.isArray(sprit_data)){
                    sprit_num = Number(sprit_data[sprit_index])
                }else{
                    sprit_num = Number(sprit_data)
                }

                let cap_all_length  = scope.load_excel_data.select[scope.form_data.step_2][scope.form_data.step_3][scope.form_data.step_4]['キャップ全体寸法']
                let cap_nomi_length = scope.load_excel_data.select[scope.form_data.step_2][scope.form_data.step_3][scope.form_data.step_4]['キャップ飲込み寸法']

                const rail_data     = ( (cap_all_length - cap_nomi_length) * 2)

                //total sum
                let total_rail_data   = scope.orgFloor(scope.un_comma(scope.form_data.step_1) - rail_data, 0.1) - sprit_num

                if(total_rail_data < e.target.value){
                    alert('【STEP1】キャップを含むレールの全長を超えています。\n'+'入力できる長さは'+total_rail_data+'mm以下です。')
                    scope.step_data.step_6 = 'active_step'
                    e.target.value = ''
                    e.target.focus()
                    return false
                }

                //formdata update
                scope.form_data.step_6 = scope.comma(Number(e.target.value))
                e.target.value = scope.comma(Number(e.target.value))
                this.form_data= scope.form_data


                //stepdata update
                this.step_data= scope.step_data

                //計算処理起動
                scope.Calculation()
            },
            /**
             * reset
             */
            reset_form_data : function (){
                const scope = this
                scope.form_data.step_1 = ''
                scope.form_data.step_2 = ''
                scope.form_data.step_3 = ''
                scope.form_data.step_4 = ''
                scope.form_data.step_5 = ''
                scope.form_data.step_6 = ''

                //input all reset
                for (const element of document.getElementsByClassName('uk-input')) {
                    element.value = ''
                }

                //radio all disabled
                for (const element of document.getElementsByClassName('uk-radio')) {
                    element.checked = false;
                }
                //formdata update
                this.form_data= scope.form_data
            },
            reset_step_data: function (){
                const scope = this
                scope.step_data.step_1 = 'active_step'
                scope.step_data.step_2 = 'disabled_step'
                scope.step_data.step_3 = 'disabled_step'
                scope.step_data.step_4 = 'disabled_step'
                scope.step_data.step_5 = 'disabled_step'
                scope.step_data.step_6 = 'hidden_step'
                //formdata update
                this.step_data= scope.step_data
            },
            clear_data : function (){
                const scope = this
                if(!confirm('入力内容をクリアしますがよろしいですか？')){
                    return false
                }
                scope.reset_step_data()
                scope.reset_form_data()
                scope.resetCalculation()
                scope.scrollTop()
            },
            scrollTop : function () {
                window.scroll({
                    top: 0,
                    behavior: "smooth"
                });
            },
            /**
             * 計算処理
             */
            Calculation : function(){
                // console.log('Calculation')
                const scope = this

                if(scope.form_data.step_2 === '' || scope.form_data.step_3 === '' || scope.form_data.step_4 === '' ){
                    scope.total_data.total_rail   = ''
                    scope.total_data.default_rail = ''
                    scope.total_data.cover_rail   = ''
                    return false
                }

                let cap_all_length  = scope.load_excel_data.select[scope.form_data.step_2][scope.form_data.step_3][scope.form_data.step_4]['キャップ全体寸法']
                let cap_nomi_length = scope.load_excel_data.select[scope.form_data.step_2][scope.form_data.step_3][scope.form_data.step_4]['キャップ飲込み寸法']

                const rail_data     = ( (cap_all_length - cap_nomi_length) * 2)
                console.log(cap_all_length - cap_nomi_length)
                //total
                let total_rail_data   = scope.orgFloor(scope.un_comma(scope.form_data.step_1) - rail_data, 0.1)

                let step_6_data = scope.un_comma(scope.form_data.step_6)

                //default
                let default_rail_data = ''
                //cover
                let cover_rail_data   = ''

                let total_rail_sum = total_rail_data

                if(scope.form_data.step_5 !== 'シングル'){
                    if(scope.load_excel_data.select[scope.form_data.step_2][scope.form_data.step_3][scope.form_data.step_4][scope.form_data.step_5] === '〇'){
                       let sprit_data = scope.load_excel_data.double[scope.form_data.step_3]['ドレープ側'][scope.form_data.step_5]
                        if(isNaN(sprit_data)){
                            sprit_data = sprit_data.replace(')','').split('(Rセットの場合は')
                        }

                        let sprit_index = 0
                        if(scope.form_data.step_4 === 'R' || scope.form_data.step_4 === 'Ｒ' || scope.form_data.step_4 === 'ﾒﾀﾙR' || scope.form_data.step_4 === 'メタルＲ'){
                            sprit_index = 1
                        }

                        //console.log(scope.load_excel_data.double[scope.form_data.step_3]['ドレープ側'])
                        let sprit_num = ''
                        if(Array.isArray(sprit_data)){
                            sprit_num = Number(sprit_data[sprit_index])
                        }else{
                            sprit_num = Number(sprit_data)
                        }

                        if(scope.step_data.step_6 !== 'hidden_step') {
                            total_rail_sum = step_6_data
                            if(step_6_data === '' || step_6_data === 0){
                                total_rail_sum = ''
                                sprit_num = ''
                            }
                        }

                        //console.log(scope.load_excel_data.double[scope.form_data.step_3]['ドレープ側'])
                        if(scope.form_data.step_5 === 'ダブルカバートップ'){
                            if(scope.load_excel_data.double[scope.form_data.step_3]['ドレープ側']['ダブル（装飾＋機能性）'] !== "―"){
                                let sprit_data_2 = scope.load_excel_data.double[scope.form_data.step_3]['ドレープ側']['ダブル（装飾＋機能性）']
                                if(isNaN(sprit_data_2)){
                                    sprit_data_2 = sprit_data_2.replace(')','').split('(Rセットの場合は')
                                }
                                let sprit_num_2 = ''
                                if(Array.isArray(sprit_data_2)){
                                    sprit_num_2 = Number(sprit_data_2[sprit_index])
                                }else{
                                    sprit_num_2 = Number(sprit_data_2)
                                }
                                default_rail_data = total_rail_sum + sprit_num_2
                            }
                            if(scope.load_excel_data.double[scope.form_data.step_3]['ドレープ側']['ダブル（装飾＋装飾）'] !== "―"){
                                let sprit_data_2 = scope.load_excel_data.double[scope.form_data.step_3]['ドレープ側']['ダブル（装飾＋装飾）']
                                if(isNaN(sprit_data_2)){
                                    sprit_data_2 = sprit_data_2.replace(')','').split('(Rセットの場合は')
                                }
                                let sprit_num_2 = ''
                                if(Array.isArray(sprit_data_2)){
                                    sprit_num_2 = Number(sprit_data_2[sprit_index])
                                }else{
                                    sprit_num_2 = Number(sprit_data_2)
                                }
                                default_rail_data = total_rail_sum + sprit_num_2
                            }
                            cover_rail_data   = total_rail_sum + sprit_num
                        }else{
                            default_rail_data = total_rail_sum + sprit_num
                        }
                    }

                }

                if(scope.form_data.step_3 === 'ノルディ25' && (scope.form_data.step_4 === 'E' || scope.form_data.step_4 === 'Ｅ') && scope.form_data.step_5 !== '' && scope.form_data.step_5 !== 'シングル' && scope.form_data.step_6 === ''){
                    total_rail_data = ''
                }

                scope.total_data.total_rail   = scope.comma(total_rail_data)
                scope.total_data.default_rail = scope.comma(default_rail_data)
                scope.total_data.cover_rail   = scope.comma(cover_rail_data)

                //stepdata update
                this.total_data= scope.total_data
            },
            resetCalculation:function(){
                const scope = this
                scope.total_data.total_rail   = ""
                scope.total_data.default_rail = ""
                scope.total_data.cover_rail   = ""

                //stepdata update
                this.total_data= scope.total_data
            },
            /**
             * 任意の桁で切り捨てする関数
             * @param {number} value 切り捨てする数値
             * @param {number} base どの桁で切り捨てするか（10→10の位、0.1→小数第１位）
             * @return {number} 切り捨てした値
             */
            orgFloor : function(value, base) {
                return Math.floor(value * base) / base;
            },
            //Number変換
            changeTypeNum1 :function(e){
                const scope = this

                //formdata update
                scope.form_data.step_1 = (scope.un_comma(e.target.value)===0)?'':scope.un_comma(e.target.value)
                e.target.value = (scope.un_comma(e.target.value)===0)?'':scope.un_comma(e.target.value)
                if(e.target.value === 0){
                    e.target.value = ''
                }
                this.form_data= scope.form_data

                e.target.type = 'number'

            },
            changeTypeNum2 :function(e){
                const scope = this

                //formdata update
                scope.form_data.step_6 = (scope.un_comma(e.target.value)===0)?'':scope.un_comma(e.target.value)
                e.target.value = (scope.un_comma(e.target.value)===0)?'':scope.un_comma(e.target.value)
                if(e.target.value === 0){
                    e.target.value = ''
                }
                this.form_data= scope.form_data

                e.target.type = 'number'

            },
            // 3桁カンマ区切りとする（小数点も考慮）.
            comma : function (num) {
                let s = String(num).split('.');
                let ret = String(s[0]).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
                if (s.length > 1) {
                    ret += '.' + s[1];
                }
                return ret;
            },
            //カンマ→カンマ無し
            un_comma : function (text) {
                let result = String(text).replace(',','');
                return Number(result);
            },
            /**
             * エンターキー対応
             * @param event
             */
            trigger: function(event) {
                // 日本語入力中のEnterキー操作は無効にする
                if (event.keyCode !== 13) return
                // 実行したい処理
                //focus out
                document.activeElement.blur()
            }
        }

    }
</script>

<style lang="scss">
    @import "./assets/scss/page/top";
    @import "./assets/scss/common/loading";
</style>

